import { getRouteApi } from "@tanstack/react-router";

import clickUpLogomark from "../assets/images/clickup-logomark.svg";
import greenlightLogo from "../assets/images/greenlight-vertical.svg";
import { AuthShell } from "@/components/LoadingScreen";
import { Button } from "@/components/ui/button";

const ERROR_MESSAGES: Record<string, string> = {
  state: "Your login session expired. Please try signing in again.",
  oauth: "We couldn't reach ClickUp. Please try again.",
  revoked: "Your access has been revoked. Contact your admin.",
  not_allowed: "You don't have access yet. Ask your admin for an invite.",
};

const route = getRouteApi("/login");

export function Login() {
  const { error } = route.useSearch();
  const message = error
    ? (ERROR_MESSAGES[error] ?? "Something went wrong. Please try again.")
    : null;

  return (
    <AuthShell
      logo={
        <img src={greenlightLogo} alt="Greenlight" className="h-32 w-auto" />
      }
    >
      <p className="text-sm text-muted-foreground">
        Sign in to your workspace with ClickUp.
      </p>

      {message && (
        <div
          role="alert"
          className="mt-6 w-full rounded-md border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-destructive"
        >
          {message}
        </div>
      )}

      <Button asChild variant="outline" className="mt-6 h-12 min-w-64 px-5">
        <a href="/auth/login">
          <img src={clickUpLogomark} alt="" className="size-4" aria-hidden="true" />
          Sign in with ClickUp
        </a>
      </Button>

      <p className="mt-7 text-sm text-muted-foreground">
        Need access? Ask your admin for an invite.
      </p>
    </AuthShell>
  );
}

export default Login;
